import React, { useCallback, useEffect, useRef, useState } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_ButtonLink } from "@danishagro/shared/src/components/atoms/ButtonLink/ButtonLink.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import S from "./ShortDescriptionV1.module.scss";

interface V1Props {
    description?: string;
    allowQuickOrder?: boolean;
}

const V1 = ({ description, allowQuickOrder }: V1Props) => {
    const { getDictionaryString } = useTranslations();
    const [toggleDescription, setToggleDescription] = useState(false);
    const [isClamped, setIsClamped] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    const checkClamped = useCallback(() => {
        if (textRef.current && !toggleDescription) {
            setIsClamped(textRef.current.scrollHeight > textRef.current.clientHeight);
        }
    }, [toggleDescription]);

    useEffect(() => {
        checkClamped();
        window.addEventListener("resize", checkClamped);
        return () => window.removeEventListener("resize", checkClamped);
    }, [checkClamped, description, allowQuickOrder]);

    return description ? (
        <DA_Container>
            <div
                className={cn(
                    S.descriptionTextWrapper,
                    allowQuickOrder && S.descriptionTextWrapperWithQuickOrderPadding
                )}
            >
                <div
                    ref={textRef}
                    className={cn(S.descriptionText, toggleDescription && S.showText)}
                >
                    <DA_Text noPadding html={description} />
                </div>
                {(isClamped || toggleDescription) && (
                    <DA_ButtonLink
                        icon={DA_IconNames.ChevronSmallDown}
                        className={cn(S.link, toggleDescription ? S.linkIconLess : S.linkIconMore)}
                        title={
                            toggleDescription
                                ? getDictionaryString("showLess")
                                : getDictionaryString("showMore")
                        }
                        onClick={() => setToggleDescription(!toggleDescription)}
                    />
                )}
            </div>
        </DA_Container>
    ) : null;
};

export default V1;
